import { motion } from 'framer-motion';
import { Phone, MessageCircle, MapPin, MessageSquare, Share2 } from 'lucide-react';
import { MessageCircle as WhatsAppIcon } from 'lucide-react';

/**
 * BusinessContact - Premium contact section with elegant action buttons
 */
export function BusinessContact({
    phoneNumber,
    whatsappAvailable,
    websiteUrl,
    channelUrl,
    location,
    onLocationClick,
    onNotificationClick,
    onReviewsClick,
    onShareClick
}) {
    const contactItems = [
        phoneNumber && {
            icon: Phone,
            label: 'חייג',
            onClick: () => window.location.href = `tel:${phoneNumber.replace(/[^0-9+]/g, '')}`
        },
        phoneNumber && whatsappAvailable && {
            icon: WhatsAppIcon,
            label: 'WhatsApp',
            onClick: () => window.open(`https://wa.me/${phoneNumber.replace(/[^0-9]/g, '')}`, '_blank')
        },
        location && location !== "None" && onLocationClick && {
            icon: MapPin,
            label: 'מיקום',
            onClick: onLocationClick
        },
        channelUrl && {
            icon: MessageSquare,
            label: 'ערוץ',
            onClick: () => window.open(channelUrl, '_blank')
        },
        onReviewsClick && {
            icon: MessageCircle,
            label: 'תגובות',
            onClick: onReviewsClick
        },
        onShareClick && {
            icon: Share2,
            label: 'שתף',
            onClick: onShareClick
        }
    ].filter(Boolean);

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="px-6 py-6 bg-warning-50/30 border-t border-warning-100/50"
        >
            <div className="mb-5">
                <h3 className="text-sm font-bold text-warning-700/80 tracking-tight">פעולות מהירות</h3>
            </div>
            <div className="flex flex-wrap justify-center gap-6 sm:gap-8">
                {contactItems.map((item, idx) => {
                    const Icon = item.icon;
                    return (
                        <motion.button
                            key={idx}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.25 + idx * 0.05 }}
                            whileHover={{ y: -3, scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={item.onClick}
                            className="group flex flex-col items-center gap-2 transition-all duration-300"
                        >
                            {/* Icon */}
                            <div className="w-14 h-14 rounded-full bg-warning-100/80 flex items-center justify-center group-hover:bg-warning-100/80 transition-colors duration-300">
                                <Icon className="w-6 h-6 text-warning-700 group-hover:text-warning-700" strokeWidth={2} />
                            </div>

                            {/* Label */}
                            <span className="text-xs font-semibold text-warning-700/70 group-hover:text-warning-700 transition-colors">
                                {item.label}
                            </span>
                        </motion.button>
                    );
                })}
            </div>
        </motion.div>
    );
}

export default BusinessContact;
